// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"az_vIb"};